import React from "react";

const LoadingSpinnerContext = React.createContext();
export default LoadingSpinnerContext;
